"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Tag: function() {
        return _Tag.Tag;
    },
    renderTag_unstable: function() {
        return _Tag.renderTag_unstable;
    },
    tagClassNames: function() {
        return _Tag.tagClassNames;
    },
    useTagStyles_unstable: function() {
        return _Tag.useTagStyles_unstable;
    },
    useTag_unstable: function() {
        return _Tag.useTag_unstable;
    },
    InteractionTag: function() {
        return _InteractionTag.InteractionTag;
    },
    renderInteractionTag_unstable: function() {
        return _InteractionTag.renderInteractionTag_unstable;
    },
    interactionTagClassNames: function() {
        return _InteractionTag.interactionTagClassNames;
    },
    useInteractionTagStyles_unstable: function() {
        return _InteractionTag.useInteractionTagStyles_unstable;
    },
    useInteractionTag_unstable: function() {
        return _InteractionTag.useInteractionTag_unstable;
    },
    useInteractionTagContextValues_unstable: function() {
        return _InteractionTag.useInteractionTagContextValues_unstable;
    },
    InteractionTagPrimary: function() {
        return _InteractionTagPrimary.InteractionTagPrimary;
    },
    interactionTagPrimaryClassNames: function() {
        return _InteractionTagPrimary.interactionTagPrimaryClassNames;
    },
    renderInteractionTagPrimary_unstable: function() {
        return _InteractionTagPrimary.renderInteractionTagPrimary_unstable;
    },
    useInteractionTagPrimaryStyles_unstable: function() {
        return _InteractionTagPrimary.useInteractionTagPrimaryStyles_unstable;
    },
    useInteractionTagPrimary_unstable: function() {
        return _InteractionTagPrimary.useInteractionTagPrimary_unstable;
    },
    InteractionTagSecondary: function() {
        return _InteractionTagSecondary.InteractionTagSecondary;
    },
    renderInteractionTagSecondary_unstable: function() {
        return _InteractionTagSecondary.renderInteractionTagSecondary_unstable;
    },
    interactionTagSecondaryClassNames: function() {
        return _InteractionTagSecondary.interactionTagSecondaryClassNames;
    },
    useInteractionTagSecondaryStyles_unstable: function() {
        return _InteractionTagSecondary.useInteractionTagSecondaryStyles_unstable;
    },
    useInteractionTagSecondary_unstable: function() {
        return _InteractionTagSecondary.useInteractionTagSecondary_unstable;
    },
    TagGroup: function() {
        return _TagGroup.TagGroup;
    },
    renderTagGroup_unstable: function() {
        return _TagGroup.renderTagGroup_unstable;
    },
    tagGroupClassNames: function() {
        return _TagGroup.tagGroupClassNames;
    },
    useTagGroupStyles_unstable: function() {
        return _TagGroup.useTagGroupStyles_unstable;
    },
    useTagGroup_unstable: function() {
        return _TagGroup.useTagGroup_unstable;
    },
    useTagGroupContextValues_unstable: function() {
        return _TagGroup.useTagGroupContextValues_unstable;
    },
    useTagAvatarContextValues_unstable: function() {
        return _utils.useTagAvatarContextValues_unstable;
    }
});
const _Tag = require("./Tag");
const _InteractionTag = require("./InteractionTag");
const _InteractionTagPrimary = require("./InteractionTagPrimary");
const _InteractionTagSecondary = require("./InteractionTagSecondary");
const _TagGroup = require("./TagGroup");
const _utils = require("./utils");
